<template>
  <fieldset class="fieldset">
    <legend class="fieldset__legend">
      {{ legend }}

      <HelpTooltip v-if="description">
        <template #title>
          {{ legend }}
        </template>
        <template #description>
          {{ description }}
        </template>
      </HelpTooltip>
    </legend>

    <slot></slot>
  </fieldset>
</template>

<script>
import HelpTooltip from '@/components/generics/HelpTooltip.vue'

export default {
  components: {
    HelpTooltip,
  },

  props: {
    legend: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
      default: undefined,
    },
  },
}
</script>

<style lang="scss" scoped>
.fieldset {
  border: none;
  padding: 0;
  margin: 0;

  &__legend {
    @include formLabelStyle($margin-bottom: $spacing-4xs);
    display: flex;
    align-items: center;
    gap: $spacing-5xs;
  }
}
</style>
